export const FUNCTIONS_LIST: Record<string, Function> = {
    atob: atob,
    btoa: btoa,
    'JSON.stringify': JSON.stringify,
    objectToBase64: (obj: any) => {
        if (!obj || typeof obj !== 'object') {
            return btoa(String(obj));
        }

        return btoa(JSON.stringify(obj));
    },
    basicAuthToBase64: (authValue: string) => {
        const splittedAuth = authValue.split('Basic ');
        return `Basic ${btoa(splittedAuth[1])}`;
    },
    urlParamToBase64: (url: string, paramName: string) => {
        /*trasforma in base 64 il parametro specificato gia presente nella uri*/
        let paramValue = new URLSearchParams(url).get(paramName);

        if (paramValue === null || paramValue === undefined) {
            paramValue = String(paramValue);
        }
        const b64Param = btoa(paramValue);

        return url.replace(paramValue, b64Param);
    },
};
